import {
  Button,
  InputPicker,
  Input,
  InputNumber,
  Popover,
  Whisper,
} from "rsuite";
import styles from "./AccountCodeBlock.module.css";
import { useAccountCodeBlock } from "./useAccountCodeBlock";

function AccountCodeBlock({
  readonly,
  formMode,
  invoiceCodes,
  accountNumberOptions,
  total_by_accounts,
}) {
  const {
    addItem,
    deleteAccount,
    accountHandler,
    itemHandler,
    handleSaveAmount,
  } = useAccountCodeBlock();

  const allowedToDelete = true;
  const addButton = (
    <>
      {/* <Button
        disabled={readonly}
        onClick={() => addItem()}
        appearance="primary"
        style={{
          width: 30,
          height: 30,
          fontWeight: 800,
          margin: "5px 0px 30px 0px",
        }}
      >
        ＋
      </Button> */}
      <Button
        disabled={readonly}
        onClick={() => addItem()}
        appearance="subtle"
        style={{
          width: 25,
          height: 25,
          fontWeight: 800,
          color: "green",
        }}
      >
        ＋
      </Button>
    </>
  );

  const DeleteIcon = ({ onClick }) => {
    return (
      <div>
        <Button
          className={styles.delete_button}
          disabled={readonly}
          onClick={onClick}
          appearance="subtle"
          style={{
            width: 25,
            height: 25,
          }}
        >
          ✖
        </Button>
      </div>
    );
  };
  const inputHandler = (e, rowIndex, colIndex) => {
    itemHandler(e, rowIndex, colIndex);
  };

  const codeHandler = (e, rowIndex, colIndex) => {
    accountHandler(e, rowIndex, colIndex);
  };

  const deleteHandler = (e, rowIndex) => {
    deleteAccount(rowIndex);
  };

  if (total_by_accounts == undefined) {
    const total = invoiceCodes.reduce(
      (total, row) => total + parseFloat(row[1]),
      0
    );
    total_by_accounts = isNaN(total.toFixed(2)) ? "0.00" : total.toFixed(2);
  }

  const tipAddAccount = <Popover>Add new account code</Popover>;

  const tipTotalAccount = <Popover>Total by account codes</Popover>;

  return (
    <>
      <div key="account_codes" className={styles.container}>
        <div className={styles.accounts_title}>
          <div>Account Code</div>
          <div>Amount</div>
        </div>
        {invoiceCodes.map((item, rowIndex) => (
          <div className={styles.accounts_container}>
            <InputPicker
              readOnly={readonly}
              cleanable={false}
              name="invoice_account"
              onChange={(e) => {
                codeHandler(e, rowIndex);
              }}
              value={item[0]}
              placeholder="Select account"
              groupBy="category"
              data={accountNumberOptions}
              style={{
                width: "200px",
                border: item[0] ? "1px solid #ccc" : "1px solid red",
              }}
              menuStyle={{ width: "300px" }}
            />

            <InputNumber
              id={`account-code-${rowIndex}`}
              key={`${rowIndex}`}
              readOnly={readonly}
              onChange={(e) => {
                inputHandler(e, rowIndex);
              }}
              value={item[1]}
              placeholder="" //{`Column ${colIndex + 1}`}
              style={{ width: "150px" }}
            />

            {rowIndex == 0 && (
              <div className={styles.add_accounts}>
                <Whisper
                  delay={500}
                  placement="bottomStart"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={tipAddAccount}
                >
                  <div className={styles.buttons}>{!readonly && addButton}</div>
                </Whisper>
              </div>
            )}
            {rowIndex > 0 && (
              <div
                style={{
                  paddingLeft: "45px",
                  height: "23px",
                  width: "23px",
                  paddingTop: "5px",
                }}
              >
                {!readonly && (
                  <DeleteIcon
                    onClick={(e) => {
                      deleteHandler(e, rowIndex);
                    }}
                  />
                )}
              </div>
            )}
          </div>
        ))}
        <div className={styles.accounts_total}>
          <div style={{ padding: "18px 0 0 150px", height: "35px" }}>Total</div>
          <Whisper
            delay={500}
            placement="bottomStart"
            controlId="control-id-hover"
            trigger="hover"
            speaker={tipTotalAccount}
          >
            <Input
              id={`account-code-total`}
              readOnly={true}
              value={total_by_accounts}
              placeholder="" //{`Column ${colIndex + 1}`}
              style={{
                width: "150px",
                height: "35px",
                margin: "10px 0 0 45px",
              }}
            />
          </Whisper>
        </div>
      </div>
    </>
  );
}

// };
// export const DeleteIcon = ({ onClick }) => {
//   return (
//     <>
//       <Button
//         onClick={onClick}
//         appearance="subtle"
//         style={{ width: 35, height: 35 }}
//       >
//         <svg
//           // onClick={onDelete}
//           xmlns="http://www.w3.org/2000/svg"
//           width="20"
//           height="20"
//           viewBox="0 0 20 20"
//           fill="none"
//         >
//           <path
//             d="M15 5L5 15"
//             stroke="#EF4B4B"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//           <path
//             d="M15 5L5 15"
//             stroke="#EF4B4B"
//             strokeOpacity="0.5"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//           <path
//             d="M5 5L15 15"
//             stroke="#EF4B4B"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//           <path
//             d="M5 5L15 15"
//             stroke="#EF4B4B"
//             strokeOpacity="0.5"
//             strokeWidth="1.5"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           />
//         </svg>
//       </Button>
//     </>
//   );
// };

export default AccountCodeBlock;
